export default __webpack_public_path__ + "static/media/liiv-slider-kolagen.cddf64a6.jpg";